/* Studio Mottos frame preview v1.7.0. Display only: never writes forms, SKUs, prices or cart data. */
(function(global){
  'use strict';
  const normalize=v=>String(v??'').toLowerCase().replace(/[×✕]/g,'x').replace(/[″“”"']/g,'').replace(/\s+/g,'').trim();
  const match=(values,value)=>values.some(v=>normalize(v)===normalize(value));
  function sizeFor(profile,label){
    // Older Printumo labels include both units and sometimes an ISO paper name.
    // Prefer an exact existing label, then the metric portion or explicit ISO tag.
    const raw=String(label??'');
    const metric=raw.match(/^\s*([\d.]+)\s*[x×✕]\s*([\d.]+)\s*cm\s*\//i);
    const iso=raw.match(/\(\s*(A[0-5])\s*\)\s*$/i);
    const candidates=[raw];
    if(metric)candidates.push(metric[1]+' x '+metric[2]+' cm');
    if(iso)candidates.push(iso[1]);
    for(const candidate of candidates){
      const n=normalize(candidate);
      for(const row of profile.sizes||[]){
        if(match([row.label,...(row.aliases||[])],candidate)) return {...row,cm:[...row.cm],matCm:row.matCm?[...row.matCm]:null};
        const wanted=n.match(/^([\d.]+)x([\d.]+)(cm)?$/);
        const original=normalize(row.label).match(/^([\d.]+)x([\d.]+)(cm)?$/);
        if(wanted&&original&&wanted[1]===original[2]&&wanted[2]===original[1]&&wanted[3]===original[3])
          return {...row,cm:[row.cm[1],row.cm[0]],matCm:row.matCm?[row.matCm[1],row.matCm[0]]:null};
        // Profiles may store metric dimensions under an ISO label, such as A4.
        if(metric&&candidate!==raw&&candidate!==iso?.[1]&&wanted?.[3]==='cm'){
          const w=Number(wanted[1]),h=Number(wanted[2]);
          if(w===row.cm[0]&&h===row.cm[1])return {...row,cm:[...row.cm],matCm:row.matCm?[...row.matCm]:null};
          if(w===row.cm[1]&&h===row.cm[0])return {...row,cm:[row.cm[1],row.cm[0]],matCm:row.matCm?[row.matCm[1],row.matCm[0]]:null};
        }
      }
    }
    throw Error('No dimensions configured for size: '+label);
  }
  function geometry(profile,variant,optionNames){
    if(!variant?.id) throw Error('No valid selected variant');
    const value=name=>{const i=optionNames.findIndex(n=>normalize(n)===normalize(name));if(i<0)throw Error('Missing product option: '+name);return variant.options?.[i]??variant['option'+(i+1)];};
    const sizeLabel=value(profile.sizeOption), frameLabel=value(profile.frameOption);
    const matLabel=profile.matOption?value(profile.matOption):null;
    const row=sizeFor(profile,profile.previewSize||sizeLabel);
    const unframed=match(profile.unframed||[],frameLabel);
    const frameEntry=Object.entries(profile.frames||{}).find(([name])=>normalize(name)===normalize(frameLabel));
    if(!unframed&&!frameEntry)throw Error('Unknown frame option: '+frameLabel);
    let mat=false;
    if(matLabel!==null){
      if(match(profile.matValues||[],matLabel))mat=true;
      else if(!match(profile.noMat||[],matLabel))throw Error('Unknown mat option: '+matLabel);
    }
    if(mat&&(!row.matCm||profile.matAvailable===false))throw Error('No mat dimensions for this selection');
    if(mat&&unframed&&profile.matWithoutFrame!=='printed-border')throw Error('Unframed mat behavior is not configured');
    const [w,h]=row.cm, face=unframed?0:Number(row.faceCm??profile.faceCm);
    const [aw,ah]=mat?row.matCm:[w,h];
    if(![w,h,aw,ah].every(v=>Number.isFinite(v)&&v>0)||!Number.isFinite(face)||face<0||aw>w||ah>h)throw Error('Invalid frame or mat dimensions');
    return {w,h,aw,ah,face,outerW:w+2*face,outerH:h+2*face,mat,unframed,texture:frameEntry?.[1],sizeLabel,frameLabel,matLabel};
  }
  function cropRect(iw,ih,w,h,fit='cover',fx=.5,fy=.5){
    if(fit==='contain'){
      const s=Math.min(w/iw,h/ih);return {sx:0,sy:0,sw:iw,sh:ih,dx:(w-iw*s)/2,dy:(h-ih*s)/2,dw:iw*s,dh:ih*s};
    }
    const s=Math.max(w/iw,h/ih),sw=w/s,sh=h/s;
    return {sx:(iw-sw)*Math.max(0,Math.min(1,fx)),sy:(ih-sh)*Math.max(0,Math.min(1,fy)),sw,sh,dx:0,dy:0,dw:w,dh:h};
  }
  function matOpening(g){
    if(!g.mat)return '';
    const inches=v=>Number((v/2.54).toFixed(2)).toString();
    return 'Mat opening: '+inches(g.aw)+' × '+inches(g.ah)+' in';
  }
  function previewCaption(g,profile){
    const names={natural:'Natural Oak Frame',dark:'Walnut Oak Frame',black:'Black Oak Frame',white:'White Oak Frame'};
    const frame=g.unframed?'Unframed Print':(profile.frameDisplayNames?.[g.texture]||names[g.texture]||g.frameLabel);
    const mat=g.mat?(profile.matDisplayName||'White Mat'):'No Mat';
    return g.sizeLabel+' · '+frame+' - '+mat+(g.mat?'\n'+matOpening(g):'');
  }
  function previewLayout(g,profile,resolution){
    // Always reserve the same frame margin, even while displaying unframed paper.
    const row=sizeFor(profile,profile.previewSize||g.sizeLabel),face=Number(row.faceCm??profile.faceCm);
    if(!Number.isFinite(face)||face<0)throw Error('Invalid reserved frame dimensions');
    const scale=Math.min(resolution*.80/(g.w+2*face),resolution*.80/(g.h+2*face));
    const W=g.outerW*scale,H=g.outerH*scale,F=g.face*scale;
    return {scale,W,H,F,x:(resolution-W)/2,y:(resolution-H)/2};
  }
  const api={normalize,sizeFor,geometry,cropRect,matOpening,previewLayout,previewCaption};
  if(typeof module!=='undefined'&&module.exports){module.exports=api;return;}
  global.SMFramePreviewMath=api;
  if(customElements.get('sm-frame-preview'))return;
  const cache=new Map();
  function loadProfile(url){if(!cache.has(url))cache.set(url,fetch(url).then(r=>{if(!r.ok)throw Error('Frame profile could not be loaded');return r.json();}).catch(e=>{cache.delete(url);throw e;}));return cache.get(url);}
  function ready(img){return new Promise((resolve,reject)=>{if(img.complete){img.naturalWidth?resolve(img):reject(Error('Preview image unavailable'));return;}img.addEventListener('load',()=>resolve(img),{once:true});img.addEventListener('error',()=>reject(Error('Preview image unavailable')),{once:true});});}
  class FramePreview extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();this.version=0;
      this.boot().catch(e=>this.fail(e));
    }
    disconnectedCallback(){this.abort.abort();this.resize?.disconnect();this.version++;}
    async boot(){
      const parse=s=>JSON.parse(this.querySelector(s).textContent);
      this.variant=parse('[data-preview-variant]');this.options=parse('[data-preview-options]');
      this.variants=parse('[data-preview-variants]');
      this.profile=parse('[data-preview-profile]')||await loadProfile(this.dataset.profileUrl);
      if(typeof this.profile==='string')this.profile=JSON.parse(this.profile);
      if(!this.isConnected)return;
      this.art=this.querySelector('[data-preview-artwork]');this.canvas=this.querySelector('[data-preview-canvas]');
      this.caption=this.querySelector('[data-preview-caption]');
      this.textures=Object.fromEntries([...this.querySelectorAll('[data-preview-texture]')].map(i=>[i.dataset.previewTexture,i]));
      const signal=this.abort.signal;
      if(this.hasAttribute('data-cart-preview')){
        this.resize=new ResizeObserver(()=>{if(this.state)this.draw(this.canvas,this.state);});
        this.resize.observe(this);await this.update();return;
      }
      const form=document.getElementById(this.dataset.form);
      if(!form)throw Error('Product form not found');
      form.addEventListener('variant:change',e=>this.syncVariant(e.detail.variant),{signal});
      const section=this.closest('.shopify-section')||this.closest('product-rerender')||this.closest('product-gallery').parentElement;
      document.addEventListener('sm:variant-change',e=>{
        // The current Printumo configurator bubbles this internal event from its root.
        if(section.contains(e.target)||e.detail?.formId===this.dataset.form)
          this.syncVariant(e.detail?.variant);
      },{signal});
      // The configurator silently writes the real form ID; its hidden native picker can be stale.
      const actualId=form.querySelector('[name="id"]')?.value;
      const current=this.variants.find(v=>String(v.id)===String(actualId));
      if(current)this.variant=current;
      this.resize=new ResizeObserver(()=>{if(this.state)this.draw(this.canvas,this.state);});this.resize.observe(this);
      await this.update();
      this.warmTextures();
    }
    warmTextures(){
      const connection=navigator.connection;
      if(this.hasAttribute('data-cart-preview')||connection?.saveData||/^(slow-)?2g$/.test(connection?.effectiveType||''))return;
      const queue=Object.values(this.textures).filter(img=>!img.getAttribute('src'));
      const next=()=>{if(!this.isConnected||!queue.length||document.visibilityState==='hidden')return;
        const img=queue.shift();img.fetchPriority='low';if(!img.getAttribute('src'))img.src=img.dataset.src;
        ready(img).catch(()=>{}).finally(()=>{if(queue.length)schedule();});};
      const schedule=()=>{if(global.requestIdleCallback)global.requestIdleCallback(next,{timeout:3000});else global.setTimeout(next,300);};
      schedule();
    }
    getZoomData(){
      if(!this.state||this.dataset.ready!=='true')return null;
      const canvas=document.createElement('canvas');
      this.draw(canvas,this.state,1600);
      const src=canvas.toDataURL('image/png');
      return {thumbnailElement:this.canvas,src,msrc:src,width:1600,height:1600,alt:this.canvas.getAttribute('aria-label')||this.art.alt,thumbCropped:false};
    }
    syncVariant(variant){
      if(!variant)return Promise.resolve();
      if(this.dataset.ready==='true' && String(this.variant?.id)===String(variant.id))return Promise.resolve();
      this.variant=variant;
      return this.update().then(()=>{
        const carousel=this.closest('product-gallery')?.carousel;
        const cell=this.closest('.product-gallery__media');
        if(carousel?.isScrollable&&this.dataset.ready==='true')requestAnimationFrame(()=>{
          if(this.isConnected)carousel.select(carousel.cells.indexOf(cell),{instant:true});
        });
      });
    }
    async update(){
      const token=++this.version;
      try{
        const state=geometry(this.profile,this.variant,this.options);
        await ready(this.art);
        if(!state.unframed){const texture=this.textures[state.texture];if(!texture)throw Error('Frame texture unavailable');if(!texture.getAttribute('src'))texture.src=texture.dataset.src;await ready(texture);}
        if(token!==this.version||!this.isConnected)return;
        this.state=state;this.draw(this.canvas,state);
        this.art.hidden=true;this.canvas.hidden=false;this.dataset.ready='true';
        this.querySelector('[data-preview-error]').hidden=true;
        this.querySelector('[data-preview-loading]').hidden=true;

        this.caption.textContent=previewCaption(state,this.profile);this.caption.hidden=true;
        this.canvas.setAttribute('aria-label',this.caption.textContent);

      }catch(e){if(token===this.version)this.fail(e);}
    }
    fail(error){
      if(!this.isConnected)return;
      if(this.hasAttribute('data-cart-preview')){this.dataset.ready='false';this.state=null;this.hidden=true;return;}
      this.dataset.ready='false';this.state=null;
      this.querySelector('[data-preview-loading]').hidden=true;
      this.querySelector('[data-preview-artwork]').hidden=false;
      this.querySelector('[data-preview-canvas]').hidden=true;

      this.querySelector('[data-preview-caption]').hidden=true;

      const msg=this.querySelector('[data-preview-error]');
      // Do not show a stale frame for unsupported or invalid combinations.
      msg.textContent=this.hasAttribute('data-editor')?error.message:'Frame preview unavailable for this selection.';msg.hidden=false;
      console.warn('[SM frame preview]',error.message);
    }
    drawPhotographicFrame(c,g,{x,y,W,H,F}){
      const surface=this.textures[g.texture],iw=surface.naturalWidth,ih=surface.naturalHeight;
      const coordinates=this.profile.frontPhoto?.[g.texture]||this.profile.frontPhoto||{};
      const bounds=coordinates.bounds||[.196875,.125,.803125,.875];
      const face=(coordinates.faceWidth||.0265625)*iw;
      const [l,t,r,b]=[bounds[0]*iw,bounds[1]*ih,bounds[2]*iw,bounds[3]*ih];
      if(![l,t,r,b,face].every(Number.isFinite)||face<=0||r<=l+2*face||b<=t+2*face)throw Error('Invalid frame front-photo coordinates');
      const sw=r-l,sh=b-t,pad=0,sourceCorner=face+pad,targetCorner=F*(1+pad/face);
      const sx=[l,l+sourceCorner,r-sourceCorner],sy=[t,t+sourceCorner,b-sourceCorner];
      const widths=[sourceCorner,sw-2*sourceCorner,sourceCorner],heights=[sourceCorner,sh-2*sourceCorner,sourceCorner];
      const dx=[x,x+targetCorner,x+W-targetCorner],dy=[y,y+targetCorner,y+H-targetCorner];
      const dw=[targetCorner,W-2*targetCorner,targetCorner],dh=[targetCorner,H-2*targetCorner,targetCorner];
      // Eight patches preserve all four original corners and each edge's own lighting/grain.
      for(let row=0;row<3;row++)for(let col=0;col<3;col++){
        if(row===1&&col===1)continue;
        // Slightly overlap neighboring patches to prevent subpixel seams after scaling.
        const extraX=col<2?.5:0,extraY=row<2?.5:0;
        c.drawImage(surface,sx[col],sy[row],widths[col]*(1+extraX/dw[col]),heights[row]*(1+extraY/dh[row]),dx[col],dy[row],dw[col]+extraX,dh[row]+extraY);
      }
    }
    draw(canvas,g,fixed){
      const resolution=fixed||(this.hasAttribute('data-cart-preview')?360:0)||Math.min(1600,Math.max(600,Math.round(this.clientWidth*Math.min(devicePixelRatio||1,2))));
      canvas.width=resolution;canvas.height=resolution;
      const c=canvas.getContext('2d');
      const {scale,W,H,F,x,y}=previewLayout(g,this.profile,resolution);
      c.fillStyle='#f8f7f5';c.fillRect(0,0,resolution,resolution);
      if(!g.unframed){c.save();c.shadowColor='rgba(0,0,0,.16)';c.shadowBlur=resolution*.016;c.shadowOffsetY=resolution*.009;c.fillStyle='#fff';c.fillRect(x,y,W,H);c.restore();}
      c.fillStyle=g.mat?(this.profile.matColor||'#fafaf9'):'#faf9f6';c.fillRect(x+F,y+F,g.w*scale,g.h*scale);
      // Keep a subtle outer paper edge for an unframed mat.
      if(g.mat&&g.unframed){
        c.strokeStyle='rgba(70,65,55,.14)';c.lineWidth=resolution/600;
        c.strokeRect(x,y,W,H);
      }
      const ax=x+F+(g.w-g.aw)*scale/2,ay=y+F+(g.h-g.ah)*scale/2,aw=g.aw*scale,ah=g.ah*scale;
      const fit=this.dataset.fit==='contain'?'contain':'cover';
      const rect=cropRect(this.art.naturalWidth,this.art.naturalHeight,aw,ah,fit,Number(this.dataset.focusX)/100,Number(this.dataset.focusY)/100);
      c.drawImage(this.art,rect.sx,rect.sy,rect.sw,rect.sh,ax+rect.dx,ay+rect.dy,rect.dw,rect.dh);
      // The bevel sits outside the configured opening, preserving the real artwork window.
      // Render the same window bevel with or without a frame.
      if(g.mat){
        const bevelCm=Number(this.profile.matBevelCm??.18);
        const matMargin=Math.min((g.w-g.aw)*scale/2,(g.h-g.ah)*scale/2);
        const B=Math.min(Math.max(resolution*.002,scale*(Number.isFinite(bevelCm)&&bevelCm>=0?bevelCm:.18)),matMargin*.35);
        const strip=(points,x1,y1,x2,y2,start,end)=>{
          c.save();c.beginPath();points.forEach(([px,py],i)=>i?c.lineTo(px,py):c.moveTo(px,py));c.closePath();
          const gradient=c.createLinearGradient(x1,y1,x2,y2);
          gradient.addColorStop(0,start);gradient.addColorStop(1,end);c.fillStyle=gradient;c.fill();c.restore();
        };
        if(B>0){
          strip([[ax-B,ay-B],[ax+aw+B,ay-B],[ax+aw,ay],[ax,ay]],ax,ay-B,ax,ay,'#e8e8e5','#d5d5d1');
          strip([[ax-B,ay-B],[ax,ay],[ax,ay+ah],[ax-B,ay+ah+B]],ax-B,ay,ax,ay,'#ecece9','#dadad6');
          strip([[ax+aw,ay],[ax+aw+B,ay-B],[ax+aw+B,ay+ah+B],[ax+aw,ay+ah]],ax+aw,ay,ax+aw+B,ay,'#ffffff','#f6f6f3');
          strip([[ax,ay+ah],[ax+aw,ay+ah],[ax+aw+B,ay+ah+B],[ax-B,ay+ah+B]],ax,ay+ah,ax,ay+ah+B,'#ffffff','#f6f6f3');
        }
      }
      if(F){
        this.drawPhotographicFrame(c,g,{x,y,W,H,F});
        // Soft, bounded contact shadow. Never samples the photographed empty opening.
        const px=x+F,py=y+F,pw=W-2*F,ph=H-2*F,depth=Math.max(1.2,Math.min(F*.38,resolution*.008));
        const shade=(x1,y1,x2,y2,bounds,opacity)=>{
          const gradient=c.createLinearGradient(x1,y1,x2,y2);
          gradient.addColorStop(0,'rgba(0,0,0,'+opacity+')');gradient.addColorStop(1,'rgba(0,0,0,0)');
          c.fillStyle=gradient;c.fillRect(...bounds);
        };
        shade(px,py,px,py+depth,[px,py,pw,depth],.24);
        shade(px,py,px+depth,py,[px,py,depth,ph],.19);
        shade(px+pw,py,px+pw-depth,py,[px+pw-depth,py,depth,ph],.07);
        shade(px,py+ph,px,py+ph-depth,[px,py+ph-depth,pw,depth],.09);
      }
    }
  }
  customElements.define('sm-frame-preview',FramePreview);
})(typeof window==='undefined'?globalThis:window);
